/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Deload_ShortInputs */

const en_us2_plan_deload_short = /** @type {(inputs: Plan_Deload_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fewer sets on purpose`)
};

const pt_br2_plan_deload_short = /** @type {(inputs: Plan_Deload_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menos séries de propósito`)
};

const es_419_plan_deload_short = /** @type {(inputs: Plan_Deload_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menos series a propósito`)
};

const pt_pt2_plan_deload_short = /** @type {(inputs: Plan_Deload_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menos séries de propósito`)
};

const fr_fr2_plan_deload_short = /** @type {(inputs: Plan_Deload_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moins de séries, exprès`)
};

const de_de2_plan_deload_short = /** @type {(inputs: Plan_Deload_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absichtlich weniger Sätze`)
};

const it_it2_plan_deload_short = /** @type {(inputs: Plan_Deload_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meno serie apposta`)
};

/**
* | output |
* | --- |
* | "Fewer sets on purpose" |
*
* @param {Plan_Deload_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_deload_short = /** @type {((inputs?: Plan_Deload_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Deload_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_deload_short(inputs)
	if (locale === "es-419") return es_419_plan_deload_short(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_deload_short(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_deload_short(inputs)
	if (locale === "de-DE") return de_de2_plan_deload_short(inputs)
	if (locale === "it-IT") return it_it2_plan_deload_short(inputs)
	return en_us2_plan_deload_short(inputs)
});
export { plan_deload_short as "plan.deload.short" }